// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body{overflow:hidden}.te-frame-plus{width:100%;height:100%;background-color:var(--bg-color)}.te-main{display:flex;display:-ms-flexbox;flex-wrap:nowrap;align-items:left;justify-content:flex-start;height:100vh;width:100%}.te-content{display:block;width:100%;height:calc(100% - var(--footer-height) - 40px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
